import { render } from "./TextField.vue?vue&type=template&id=1c8c62a2"
import script from "./TextField.vue?vue&type=script&lang=js"
export * from "./TextField.vue?vue&type=script&lang=js"

import exportComponent from "/home/tobias/Desktop/screenads/nova-custom2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"TextField.vue"]])

export default __exports__